import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl, headersDefault } from "./index";

/** Build query string from params */
const buildQs = (params) => {
  const qs = new URLSearchParams();
  if (params.term) qs.set("term", params.term);
  if (params.page) qs.set("page", params.page);
  if (params.diet_id) qs.set("diet_id", params.diet_id);
  if (params.undesirable) qs.set("undesirable", "true");
  if (Array.isArray(params.sources)) {
    if (params.sources.length) {
      params.sources.forEach((s, i) => qs.append(`sources[${i}]`, s));
    }
  }
  if (Array.isArray(params.category_ids)) {
    if (params.category_ids.length) {
      params.category_ids.forEach((id, i) => qs.append(`category_ids[${i}]`, id));
    } else {
      qs.append("category_ids[]", "");
    }
  }
  return qs.toString();
};

/**
 * Search/browse food categories and foods.
 */
export const searchFoods = createAsyncThunk(
  "undesirableFoods/search",
  async (params, { rejectWithValue }) => {
    try {
      const qs = buildQs({
        term: params.term || "",
        page: params.page || 1,
        diet_id: params.diet_id,
        sources: params.sources || ["Food"],
        category_ids: params.category_ids,
      });
      const res = await axios.get(
        `${baseUrl}/api/v1/master-club-undesirable-foods/list?${qs}`,
        { headers: headersDefault() }
      );
      return { data: res.data, params };
    } catch (e) {
      return rejectWithValue(
        e?.response?.data?.message ?? e?.message ?? "Errore ricerca cibi"
      );
    }
  }
);

/**
 * Fetch user's personal undesirable list.
 */
export const fetchMyUndesirables = createAsyncThunk(
  "undesirableFoods/fetchMy",
  async (_, { rejectWithValue }) => {
    try {
      const qs = buildQs({
        term: "",
        page: 1,
        sources: [],
        category_ids: [],
        undesirable: true,
      });
      const res = await axios.get(
        `${baseUrl}/api/v1/master-club-undesirable-foods/list?${qs}`,
        { headers: headersDefault() }
      );
      return res.data;
    } catch (e) {
      return rejectWithValue(
        e?.response?.data?.message ?? e?.message ?? "Errore caricamento lista"
      );
    }
  }
);

/**
 * Add item to user's undesirable list.
 */
export const addUndesirable = createAsyncThunk(
  "undesirableFoods/add",
  async ({ element_id, source }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${baseUrl}/api/v1/master-club-undesirable-foods`,
        { element_id, source },
        { headers: headersDefault() }
      );
      return res.data?.data || res.data;
    } catch (e) {
      return rejectWithValue(
        e?.response?.data?.message ?? e?.message ?? "Errore aggiunta cibo"
      );
    }
  }
);

/**
 * Remove item from user's undesirable list.
 * @param {number} id - Record id (NOT element_id)
 */
export const removeUndesirable = createAsyncThunk(
  "undesirableFoods/remove",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(
        `${baseUrl}/api/v1/master-club-undesirable-foods/${id}`,
        { headers: headersDefault() }
      );
      return { id };
    } catch (e) {
      return rejectWithValue(
        e?.response?.data?.message ?? e?.message ?? "Errore rimozione cibo"
      );
    }
  }
);
